import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Observable } from 'rxjs';

import { HospitalService } from './hospital.service';

@Injectable()
export class HospitalBrokerBypassVehicleTypesResolverService  {
  constructor(private hospitalService: HospitalService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.hospitalService.getBrokerBypassVehicleTypes(route.params.id);
  }
}